import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ma-2 pa-2 text-none" }
const _hoisted_2 = {
  key: 2,
  class: "d-flex justify-center align-center flex-column",
  style: {"height":"50vh"}
}
const _hoisted_3 = {
  key: 0,
  class: "mt-10 text-h6 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BeamerUnsupportedFeatures = _resolveComponent("BeamerUnsupportedFeatures")!
  const _component_TreeFileView = _resolveComponent("TreeFileView")!
  const _component_FinalPreview = _resolveComponent("FinalPreview")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_file_upload = _resolveComponent("v-file-upload")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_SlideStudioView = _resolveComponent("SlideStudioView")!
  const _directive_motion_fade = _resolveDirective("motion-fade")!
  const _directive_motion_pop_visible = _resolveDirective("motion-pop-visible")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.showPresentationlayoutStudio && !_ctx.isFinal)
      ? (_openBlock(), _createBlock(_component_BeamerUnsupportedFeatures, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "8",
              offset: "2"
            }, {
              default: _withCtx(() => [
                (_ctx.selectedZip && _ctx.showPresentationlayoutStudio && !_ctx.isFinal)
                  ? _withDirectives((_openBlock(), _createBlock(_component_TreeFileView, {
                      key: 0,
                      zipFile: _ctx.selectedZip
                    }, null, 8, ["zipFile"])), [
                      [_directive_motion_fade]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.finalData)
                  ? _withDirectives((_openBlock(), _createBlock(_component_FinalPreview, {
                      key: 1,
                      finalData: _ctx.finalData
                    }, null, 8, ["finalData"])), [
                      [_directive_motion_fade]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                (_ctx.showPresentationlayoutStudio || _ctx.isFinal)
                  ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "ma-2 pa-2 elevation-5 font-weight-light",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {
          _ctx.showPresentationlayoutStudio = false;
          _ctx.selectedZip = undefined;
          _ctx.finalData = null;
          _ctx.isFinal = false;})
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          start: "",
                          class: "mr-2"
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode("mdi-arrow-left")
                          ])),
                          _: 1,
                          __: [3]
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.isFinal ? 'Neues Zip hochladen' : 'Zurück'), 1)
                      ]),
                      _: 1
                    })), [
                      [_directive_motion_fade]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (!_ctx.showPresentationlayoutStudio && !_ctx.isFinal)
      ? (_openBlock(), _createBlock(_component_v_container, {
          key: 1,
          fluid: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "10",
                  offset: "1"
                }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_v_sheet, { class: "d-flex justify-center flex-column align-center bg-blue-grey-lighten-4" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createVNode(_component_v_file_upload, {
                            modelValue: _ctx.selectedZip,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedZip) = $event)),
                            clearable: "",
                            density: "default",
                            color: "blue-grey-lighten-3",
                            label: "Latex-Datei hochladen",
                            "divider-text": "oder",
                            "browse-text": "Zip hochladen",
                            title: "ziehen & droppen hierher",
                            variant: "outlined",
                            accept: ".zip",
                            elevation: "5",
                            "show-size": ""
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    })), [
                      [_directive_motion_pop_visible]
                    ]),
                    (_ctx.selectedZip != null)
                      ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          class: "ma-2 pa-2 elevation-5 w-25 text-none bg-blue-grey-lighten-2",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPresentationlayoutStudio = true))
                        }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode(" Hochladen ")
                          ])),
                          _: 1,
                          __: [4]
                        })), [
                          [_directive_motion_pop_visible]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "1" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showPresentationlayoutStudio && _ctx.isLoading)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            size: 70,
            width: 7,
            color: "blue-grey-darken-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                class: "mr-2",
                size: "x-large"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("mdi-cogs")
                ])),
                _: 1,
                __: [5]
              })
            ]),
            _: 1
          }),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Ladevorgang läuft... "))
            : _createCommentVNode("", true)
        ])), [
          [_directive_motion_fade]
        ])
      : _createCommentVNode("", true),
    (_ctx.selectedZip && _ctx.showPresentationlayoutStudio)
      ? _withDirectives((_openBlock(), _createBlock(_component_SlideStudioView, {
          key: 3,
          zip: _ctx.selectedZip,
          onIsLoading: _ctx.isLoadingHandling,
          onFinalPreview: _ctx.finalPreviewHandling
        }, null, 8, ["zip", "onIsLoading", "onFinalPreview"])), [
          [_directive_motion_fade]
        ])
      : _createCommentVNode("", true)
  ], 64))
}